/**
 * ActionSheet 组件的 emit 事件声明
 */
export const actionSheetEmits = [
  /** v-model:visible 更新时触发 */
  'update:visible',
  /** 点击取消按钮时触发 */
  'cancel',
  /** 关闭时触发，点击遮罩层关闭触发 */
  'close',
  /** 选择菜单项时触发 */
  'select',
];

/**
 * ActionSheetActionItem 组件的 emit 事件声明
 */
export const actionSheetActionItemEmits = [
  /** 点击选项时触发 */
  'click',
];

/**
 * @deprecated 请使用 actionSheetEmits 或 actionSheetActionItemEmits
 * 保留此导出以兼容旧代码
 */
export const emits = actionSheetEmits;
